import React, { Component } from 'react';
import { Row } from 'antd';

import CompletedContributionsWeb from './components/CompletedContributionsWeb/CompletedContributionsWeb';
import CompletedContributionsMobile from './components/CompletedContributionsMobile/CompletedContributionsMobile';
import { CompletedContributionsWrapper, MaskDiv } from './styles';
import PropTypes from 'prop-types';

class CompletedContributions extends Component {
  componentDidMount() {
    this.props.completedContribRef.current.nextElementSibling.scrollIntoView(
      false
    );
  }

  render() {
    return (
      <Row>
        <CompletedContributionsWrapper
          containerHeight='300px'
          overFlowX={true}
          overFlowY={false}
          xs={{ span: '0' }}
          lg={{ span: '24' }}
          md={{ span: '24' }}
        >
          <CompletedContributionsWeb
            clicked={this.props.transactionClicked}
            completedContributions={this.props.completedContributions}
            config={this.props.config}
          />
        </CompletedContributionsWrapper>
        <CompletedContributionsWrapper
          xs={{ span: '24' }}
          lg={{ span: '0' }}
          md={{ span: '0' }}
          // containerHeight="424px"
          overFlowX={false}
          overFlowY={true}
        >
          <CompletedContributionsMobile
            clicked={this.props.transactionClicked}
            completedContributions={this.props.completedContributions}
            config={this.props.config}
            length={
              this.props.completedContributions &&
              this.props.completedContributions.length
            }
          />
        </CompletedContributionsWrapper>
        <MaskDiv />
      </Row>
    );
  }
}

export default CompletedContributions;

CompletedContributions.propTypes = {
  completedContribRef: PropTypes.object,
  completedContributions: PropTypes.arrayOf(
    PropTypes.shape({
      allShares: PropTypes.bool,
      amount: PropTypes.number,
      availableBalance: PropTypes.number,
      currentBalance: PropTypes.number,
      description: PropTypes.string,
      dpUser: PropTypes.string,
      dpUserFirstName: PropTypes.string,
      dpUserLastName: PropTypes.string,
      dpUserMiddleName: PropTypes.string,
      dpUserPrefix: PropTypes.string,
      dpUserSuffix: PropTypes.string,
      enteredDate: PropTypes.number,
      giftId: PropTypes.number,
      isRecurring: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      noOfShares: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      orderId: PropTypes.number,
      pendingContribution: PropTypes.bool,
      receivedDate: PropTypes.number,
      reversed: PropTypes.bool,
      settledDate: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      status: PropTypes.string,
      tradeDate: PropTypes.number,
      txnId: PropTypes.number,
      type: PropTypes.string,
      userName: PropTypes.string,
      x: PropTypes.number,
      y3: PropTypes.bool,
      y5: PropTypes.bool,
    }),
  ),
  transactionClicked: PropTypes.func,
};
